module.exports = __webpack_public_path__ + "8d43094043acc15ced6d486e63603e9a.svg";